/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Button, InputGroup, Modal,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import {
  Field, FormikConsumer, FieldArray,
} from 'formik';

import BaseGrid from '../Common/BaseGrid';
import * as url from '../../helpers/url_helper';

function ItemFieldset(props) {
  // eslint-disable-next-line no-unused-vars
  const [itemSearchModalState, setItemSearchModalState] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const { withQty, t } = props;

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const handleAddItem = (arrayHelpers, group) => {
    arrayHelpers.push({
      id: null,
      manufacturer: '',
      part_number: '',
      condition: '',
      item_qty: 1,
    });
  };

  const togItemSearch = (index) => {
    setItemSearchModalState(!itemSearchModalState);
    setCurrentIndex(index);
  };

  return (
    <FormikConsumer>
      {({
        touched, errors, values, setFieldValue,
      }) => (
        <div>
          <FieldArray name="items">
            {(arrayHelpers) => (
              <>
                <Button
                  color="primary"
                  className="btn-sm"
                  onClick={() => {
                    const num = parseInt(Object.keys(values.items).pop(), 10);
                    const groupname = Number.isNaN(num) ? 1 : num + 1;
                    handleAddItem(arrayHelpers, groupname);
                  }}
                >
                  {props.t('Add Item')}
                  &nbsp;
                  <span className="mdi mdi-plus" />
                </Button>

                <div className="vstack gap-3 mt-3">
                  {values.items.map((item, w) => (
                    <div className="hstack gap-5" key={`group_item_${w}`}>
                      {item.id == null && (
                        <>
                          <div>
                            <h5 className="text-muted mb-0">{`--${props.t('Select an item')}--`}</h5>
                          </div>
                          <div className="ms-auto">
                            <Button type="button" color="secondary" className="btn-sm btn-soft-secondary me-2" onClick={() => { togItemSearch(w); }}>
                              <span className="fas fa-search" />
                            </Button>
                            <Button color="danger" className="btn-sm btn-soft-danger" onClick={() => arrayHelpers.remove(w)}>
                              <span className="mdi mdi-close-thick" />
                            </Button>
                          </div>
                        </>
                      )}
                      {item.id != null && (
                        <>
                          <div>
                            <img src={`/api/items/thumbnail/${item.id}`} alt="" style={{ maxWidth: '64px' }} />
                          </div>
                          <div>
                            <div>
                              {item.manufacturer}
                              <br />
                              <strong>{item.part_number}</strong>
                              <br />
                              <small>{item.condition}</small>
                            </div>
                          </div>
                          {withQty && (
                            <div>
                              <InputGroup size="sm">
                                <span className="input-group-text">x</span>
                                <Field name={`items[${w}][item_qty]`} type="number" min="1" step="1" style={{ maxWidth: '70px' }} className="form-control form-control-sm" />
                              </InputGroup>
                            </div>
                          )}
                          <div className="ms-auto">
                            <Button type="button" color="secondary" className="btn-sm btn-soft-secondary me-2" onClick={() => { togItemSearch(w); }}>
                              <span className="fas fa-search" />
                            </Button>
                            <Button color="danger" className="btn-sm btn-soft-danger" onClick={() => arrayHelpers.remove(w)}>
                              <span className="mdi mdi-close-thick" />
                            </Button>
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </div>

                <Modal
                  size="lg"
                  isOpen={itemSearchModalState}
                  toggle={setItemSearchModalState}
                >
                  <div className="modal-header">
                    <h5
                      className="modal-title mt-0"
                      id="myLargeModalLabel"
                    >
                      {props.t('Search for Item')}
                    </h5>
                    <button
                      onClick={() => {
                        setItemSearchModalState(false);
                      }}
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <BaseGrid
                      url={url.GET_ITEMS}
                      hasSearch
                      config={
                      {
                        columns: {
                          thumb: {
                            label: '',
                            image: {
                              src: (item) => (`/api/items/thumbnail/${item.id}`),
                              class: 'rounded',
                              style: { maxHeight: '5rem', maxWidth: '5rem' },
                            },
                            translate: false,
                          },
                          id: { label: props.t('ID'), sort: true },
                          manufacturer: { label: props.t('Mnfctr'), sort: true },
                          part_number: { label: props.t('Part Number'), sort: true },
                          tags: {
                            label: 'Tags',
                            format: (x) => (x.map((r) => (r.label))),
                            badges: {
                              class: 'bg-info bg-soft text-dark p-2',
                            },
                          },
                          actions: {
                            label: props.t('Actions'),
                            actions: [
                              {
                                key: 'edit',
                                icon: 'mdi mdi-check-bold',
                                class: 'btn btn btn-soft-dark',
                                alt: props.t('Select'),
                                click: (item) => {
                                  const itmObj = {};
                                  itmObj.id = item.id;
                                  itmObj.manufacturer = item.manufacturer;
                                  itmObj.part_number = item.part_number;
                                  itmObj.images = item.images;

                                  // eslint-disable-next-line no-param-reassign
                                  itmObj.item_qty = 1;

                                  // Replace shortcodes in listing title
                                  if (values.title !== undefined) {
                                    let newTitle = values.title;
                                    const isMatch = newTitle.match(/\{([^}]+)\}/g);
                                    if (isMatch != null) {
                                      for (let i = 0; i < isMatch.length; i += 1) {
                                        if (item[isMatch[i].slice(1, -1)] != null) {
                                          newTitle = newTitle.replace(
                                            isMatch[i],
                                            item[isMatch[i].slice(1, -1)],
                                          );
                                          toastr.info(props.t(`${isMatch[i]} has been replaced in title`));
                                        }
                                      }

                                      setFieldValue('title', newTitle);
                                    }
                                  }

                                  // Replace shortcodes in listing sku
                                  if (values.sku !== undefined) {
                                    let newSku = values.sku;
                                    const isMatch = newSku.match(/\{([^}]+)\}/g);
                                    if (isMatch != null) {
                                      for (let i = 0; i < isMatch.length; i += 1) {
                                        if (item[isMatch[i].slice(1, -1)] != null) {
                                          newSku = newSku.replace(
                                            isMatch[i],
                                            item[isMatch[i].slice(1, -1)],
                                          );
                                          toastr.info(props.t(`${isMatch[i]} has been replaced in sku`));
                                        }
                                      }

                                      setFieldValue('sku', newSku);
                                    }
                                  }

                                  arrayHelpers.replace(currentIndex, itmObj);
                                  setItemSearchModalState(false);
                                },
                              },
                            ],
                          },
                        },
                        pagination: {
                          sort: 'id',
                          direction: 'desc',
                          perPage: 4,
                        },
                      }
                      }
                    />
                  </div>
                </Modal>
              </>
            )}
          </FieldArray>
        </div>
      )}
    </FormikConsumer>
  );
}

ItemFieldset.defaultProps = {
  t: (x) => (x),
  withQty: false,
};

ItemFieldset.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  t: PropTypes.any,
  withQty: PropTypes.bool,
};

export default connect(() => ({

}), {})(withTranslation()(ItemFieldset));
